var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLlaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "llave-de-la-puerta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_02-Door_Key",
    transform: "translate(2.5 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.18749C6.24817 8.15637 6.54975 9.10163 7.11243 9.89052L5.22188 11.7844C5.16229 11.8419 5.08285 11.8744 5 11.875L4.0625 11.875L4.0625 12.8125C4.06198 12.9849 3.92237 13.1245 3.74999 13.125L2.8125 13.125L2.8125 14.0625C2.81198 14.2349 2.67237 14.3745 2.49999 14.375L0.3125 14.375C0.140125 14.3745 0.000514686 14.2349 0 14.0625L0 11.875C0.000602901 11.7921 0.033052 11.7127 0.0906256 11.6531L4.57188 7.17499C4.44145 6.77544 4.375 6.35779 4.375 5.93749C4.37398 4.45443 5.18183 3.08875 6.48218 2.37541C7.78252 1.66206 9.36838 1.7146 10.6187 2.51244C8.16039 2.68109 6.25189 4.72343 6.25 7.18749L6.25 7.18749ZM13.8757 4.38989C13.6054 5.40224 12.896 6.24037 11.9422 6.67425C11.5539 7.21052 10.8153 7.35186 10.2564 6.99681C9.69758 6.64177 9.51169 5.91305 9.83218 5.33369C10.1527 4.75434 10.8688 4.52457 11.4665 4.80931C11.9043 4.43662 12.1636 3.89588 12.1802 3.32119C10.1714 2.67394 8.00162 3.67372 7.18845 5.62131C6.37528 7.5689 7.1899 9.81472 9.06257 10.7881L9.06257 16.8751C9.06261 16.9581 9.09556 17.0375 9.15418 17.0961L10.7166 18.6586C10.7752 18.7172 10.8547 18.7501 10.9376 18.7501C11.0205 18.7501 11.0999 18.7172 11.1585 18.6586L12.721 17.0961C12.7796 17.0375 12.8126 16.958 12.8126 16.8751C12.8126 16.7922 12.7796 16.7128 12.721 16.6542L12.0045 15.9376L12.721 15.2211C12.7796 15.1625 12.8126 15.083 12.8126 15.0001C12.8126 14.9172 12.7796 14.8378 12.721 14.7792L12.0045 14.0626L12.721 13.3461C12.7796 13.2875 12.8126 13.208 12.8126 13.1251L12.8126 10.7881C13.9458 10.2009 14.7361 9.11408 14.9453 7.85505C15.1545 6.59601 14.7582 5.31199 13.8757 4.38989L13.8757 4.38989ZM10.9375 0.625C11.9715 0.625 12.8125 1.74652 12.8125 3.125C12.8125 4.50348 11.9715 5.625 10.9375 5.625C10.7649 5.625 10.625 5.76491 10.625 5.9375C10.625 6.11009 10.7649 6.25 10.9375 6.25C12.316 6.25 13.4375 4.84818 13.4375 3.125C13.4375 1.40182 12.316 0 10.9375 0C10.0843 0.0330062 9.31406 0.520576 8.91919 1.27769C9.14551 1.30107 9.36981 1.34098 9.59029 1.39711C9.88771 0.936622 10.3899 0.648834 10.9375 0.625L10.9375 0.625Z",
    id: "Shape",
    fill: "#404040",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlaves);
export default __webpack_public_path__ + "static/media/llaves.ecffbbf4bb9ee238585fa0286c73e45e.svg";
export { ForwardRef as ReactComponent };